import * as React from 'react';

import * as styles from './styles.css';

export interface IWideButtonProps {
  onClick?(e: React.MouseEvent<HTMLElement>): void;
  testId?: string;
  children: React.ReactNode;
}

export function WideButton({ children, onClick, testId }: IWideButtonProps): React.JSX.Element {
  return (
    <button data-testid={testId} type="button" className={styles['container']} onClick={onClick}>
      {children}
    </button>
  );
}
